import useSignal from '$actions/useSignal'
import {
  callingCodes,
  fallbackCurrentCountryCode
} from '$constants/country-data'
import queryParams from '$store/queryParams'
import { settings } from '$store/settings'

export const useDefaultPhoneCode = () => {
  const {
    params: { auth_country }
  } = useSignal(queryParams)

  const setttingStore = useSignal(settings)
  const { current_network_info } = { ...setttingStore.data }

  const countryCode = (() => {
    if (auth_country) return auth_country
    if (current_network_info?.country_code)
      return current_network_info?.country_code
    return fallbackCurrentCountryCode
  })()

  const phoneCode =
    callingCodes.find(({ id }) => id === countryCode)?.code ??
    callingCodes[0].code

  return `${phoneCode}`
}

export default useDefaultPhoneCode
